import axios from 'axios'
const APIUrl = process.env.VUE_APP_API_URL

export default {
  isPublic ({ state }, pageName) {
    if (typeof pageName !== 'string') {
      return false
    }

    if (pageName.toLowerCase() === 'home') {
      return true
    }

    if (!state.pageProperties || !state.pageProperties.pages) {
      return false
    }

    const page = state.pageProperties.pages.find(page => page.pageName === pageName);
    return page ? Boolean(page.isPublic) : false
  },
  handleError: ({ commit, state }, err = { message: '', code: '99' }) => {
    if (err.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
      err.code = err.response.status
      if (err.response.status == 501) {
        return location.href = '/sitedown'
      }
    } else if (err.request) {
      /*
       * The request was made but no response was received, `err.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(err.request);
    } else {
      // Something happened in setting up the request and triggered an err
      console.log('Unexpected Error', err.message);
    }
    const page = state.pageProperties;
    const errors = page.errors[state.locale] || page.errors.en || []
    let defaultMsg = errors['default']
    console.error("Error:", err)
    if (err.cause) {
      if (errors[err.cause]) {
        return commit('setModalOptions', { type: err.isInfo ? 'info' : err.goHomeOnClose ? 'goHomeOnCloseModal' : 'error', isActive: true, message: errors[err.cause] })
      } else {
        return commit('setModalOptions', { type: err.isInfo ? 'info' : err.goHomeOnClose ? 'goHomeOnCloseModal' : 'error', isActive: true, message: defaultMsg })
      }
    } else if (err.customMsg) {
      let message = err.customMsg + "<br>Code:: " + err.code
      return commit('setModalOptions', { type: 'error', isActive: true, message: message })
    } else {
      if (err.code == '404') {
        let msg = defaultMsg + `<br>Code:: ${err.code}`
        return commit('setModalOptions', { type: 'error', isActive: true, message: msg })
      } else if (err.code == '503') {
        let msg = errors['network'] + `<br>Code:: ${err.code}`
        return commit('setModalOptions', { type: 'error', isActive: true, message: msg })
      } else if (err.code == '502') {
        let msg = errors['network'] + `<br>Code:: ${err.code}`
        return commit('setModalOptions', { type: 'error', isActive: true, message: msg })
      } else if (err.message == 'Network Error') {
        let msg = errors['network'] + `<br>Code:: 50X`
        return commit('setModalOptions', { type: 'error', isActive: true, message: msg })
      } else {
        let msg = defaultMsg + `<br>Code:: ${err.code}`
        return commit('setModalOptions', { type: 'error', isActive: true, message: msg })
      }
    }
  },

  setPageProperties: ({
    commit
  }, properties) => {
    commit('setPageProperties', properties);
  },
  refreshTempId: ({ dispatch, commit, getters }) => {
    return axios.post(`${APIUrl}/tempId`, { campaignId: getters.campaignId, jstc: 1 })
      .then(resp => {
        if (resp.data.response) {
          const data = {
            field: 'customerToken',
            value: resp.data.customerToken
          }
          if (!location.pathname.includes("/re-iban") && !location.pathname.includes("/survey") && !location.pathname.includes("/return-form")) commit('setField', data)
        }
      }).catch(err => {
        dispatch('handleError', err)
      })
  },

  setComponentStatus: ({ commit }, { component, status }) => {
    commit('setComponentStatus', { component, status });
  },
  setCampaignId: ({ commit }, campaignId) => {
    commit('setCampaignId', campaignId);
  },

  sendFormData ({ dispatch }, data) {
    return new Promise((resolve, reject) => {

      if (window.nsId) {
        data.formData.nsId = window.nsId;
      }
      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (res.data.response) {
            resolve(res.data)
          } else {
            if (res.data.invalid_fields) {
              //janrain error
              if (res.data.invalid_fields[0] == 'Email address is already in use.') {
                dispatch('handleError', { cause: 'emailUsed' })
              } else if (res.data.invalid_fields[0] == 'Incorrect username or password. Please try again.') {
                dispatch('handleError', { cause: 'incorrect' })
              } else if (res.data.invalid_fields[0] == 'No account with that email address exists.') {
                dispatch('handleError', { cause: 'noEmail' })
              } else if (res.data.message && res.data.message == 'authorization_code is not valid') {
                dispatch('handleError', { cause: 'invalidCode' })
              } else {
                dispatch('handleError', { customMsg: res.data.invalid_fields })
              }
            } else if (res.data.message) {
              dispatch('handleError', { customMsg: res.data.message })
            } else {
              dispatch('handleError', { code: res.data })
            }
            return reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },
  sendSurveyData: ({ dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (res.data.response) {
            resolve(res.data)
          } else {
            dispatch('handleError')
            reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },
  uploadProductPhotos ({ getters, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('productPhoto', data.image, 'productPhoto.png')
      formData.append('customerToken', data.customerToken)
      formData.append('campaignId', getters.campaignId)
      formData.append('receiptToken', data.receiptToken)
      axios.post(data.apiUrl, formData)
        .then(res => {
          if (res.data.response){
            if (res.data.referenceNumber)
              commit('setReferenceNumber', res.data.referenceNumber)
            resolve(res.data)
          } else {
            dispatch('handleError', res.data)
            reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },

  generateCode ({ dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      data.formData.receiptToken = state.receiptToken
      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (res.data.response) {
            return resolve(res.data)
          } else {
            dispatch('handleError', { cause: 'generateCode' })
            return reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },

  verifyCode ({ dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      data.formData.receiptToken = state.receiptToken

      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (res.data.response) {
            return resolve(res.data)
          } else {
            dispatch('handleError', { cause: 'wrongCode' })
            return reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },

  sendProducts ({ dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (res.data.response)
            resolve(res.data)
          else {
            dispatch('handleError', { customMsg: res.data.message })
            reject(res.data)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },

  uploadReceipt ({ getters, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (data.receiptToken) {
        formData.append('receiptToken', data.receiptToken)

      }
      formData.append('userToken', data.customerToken)
      formData.append('subCampaignId', getters.campaignId)
      formData.append('campaignId', data.campaignId)
      
      if (data.token) {
        formData.append('token', data.token)
      }
      formData.append('receipt', data.image, 'receipt.png')
      return axios.post(`${data.apiUrl}`, formData)
        .then(resp => {
          if (resp.data.response !== 'ERR') {
            commit('setReceiptToken', resp.data.receiptToken)
            if (resp.data.referenceNumber)
              commit('setReferenceNumber', resp.data.referenceNumber)
            return resolve(resp.data.receiptToken);
          } else {
            dispatch('handleError', resp.data.error)
          }
        })
        .catch(err => {
          if (err.response?.data?.e === 'TokenExpiredError: jwt expired') dispatch('handleError', { cause: '15minsOver', goHomeOnClose: true })
          else dispatch('handleError', err)
          reject(err)
        })
    })
  },

  uploadFile ({ commit }, file) {
    if (file) commit('setFile', file);
  },
  setImgList ({ commit }, list) {
    commit('setImgList', list);
  },
  getBarCode ({ commit }, code) {
    commit('setBarCode', code)
  },
  handleProductCode ({ commit }, value) {
    commit('setProductCode', value)
  },
  updateSearchStatus ({ commit }, status) {
    commit('setSearchStatus', status)
  },
  updateScanner ({ commit }, status) {
    commit('setScannerStatus', status)
  },
  findProducts ({ commit }, array) {
    commit('setProducts', array)
  },
  removeProduct ({ commit }, productId) {
    commit('deleteProduct', productId)
  },
  editQuantityProduct ({ commit }, { product, action, maxProductCount }) {
    commit('setQuantityProduct', { product, action, maxProductCount })
  },
  editInputQuantityProduct ({ commit }, { productId, count, maxProductCount }) {
    if (count === '0') {
      commit('deleteProduct', productId)
    } else {
      if (maxProductCount && count > maxProductCount) {
        commit('setModalOptions', { type: 'error', isActive: true, message: `Sie können nicht mehr als ${maxProductCount} Produkte auswählen.` });
        commit('setInputQuantityProduct', { productId, count: maxProductCount });
        return
      }
      commit('setInputQuantityProduct', { productId, count })
    }
  },
  searchProductByBarcode ({ state, dispatch, commit }, { barcode, maxProductCount }) {
    // Check if the same product has already been added
    if (state.scannedProducts && state.scannedProducts.find(x => {
      return x.ean === barcode
    })) {
      commit('setModalOptions', { type: 'error', isActive: true, message: `Product already added` });
      return false;
    }
    state.currentBarcode = barcode;
    let apiUrl = 'https://template-v2.justsnap.eu/api/searchBarcode';
    const isAllowed = maxProductCount ? (maxProductCount > state.scannedProducts.length && (state.scannedProducts.length ? maxProductCount > state.scannedProducts[0]?.count : true)) : true;
    if (/^[0-9]+$/.test(barcode) && isAllowed) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiUrl}`, {
            campaignId: state.campaignId,
            barcode: barcode
          })
          .then(res => {
            let status = res.data.result.length > 0 ? 'success' : 'not_found';
            // Check if the a product from same brand has already been added
            if (status === 'success' && state.scannedProducts && state.scannedProducts.find(x => {
              return x.category == res.data.result[0].category
            })) {
              commit('setModalOptions', { type: 'error', isActive: true, message: state.locale == 'de' ? `Sie haben bereits ein Produkt dieser Marke hinzugefügt.` : 'Vous avez déjà ajouté un produit de cette marque.' });
              return false;
            }

            dispatch("updateSearchStatus", status);
            dispatch("findProducts", res.data.result);

            if (status === 'not_found') {
              // The barcode is not P&G
              dispatch('updateScannerErrorMessage', 'Der Barcode scheint nicht zu einem P&G Produkt zu gehören. Glauben Sie, dass es sich um einen Fehler handelt?')
              dispatch('setErrorActivate', true)
            } else {
              dispatch('setErrorActivate', false)
            }
            resolve(res.data);
          })
      });
    } else {
      if (!isAllowed) {
        commit('setModalOptions', { type: 'error', isActive: true, message: `Sie können nicht mehr als ${maxProductCount} Produkte auswählen.` });
        dispatch("updateSearchStatus", null);
      } else {
        dispatch("updateSearchStatus", 'not_found');
        // The barcode is invalid
        dispatch('updateScannerErrorMessage', 'Der Barcode ist ungültig. Bitte versuchen Sie erneut, den Barcode einzugeben oder zu scannen. Glauben Sie, dass es sich um einen Fehler handelt?')
        dispatch('setErrorActivate', true)
      }
    }
  },
  updateScannerErrorMessage ({ commit }, error) {
    commit('setScannerError', error);
  },
  setErrorImages ({ commit }, data) {
    commit('setErrorImages', data)
  },
  setErrorActivate ({ commit }, data) {
    commit('setErrorActivate', data)
  },
  isUpdateIban:  ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axios.get(`https://template-v2.justsnap.eu/api/ibanUpdateCheck/${data.customerToken}?campaignId=${data.campaignId}`)
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  setCustomerToken: ({ commit }, data) => {
    commit('setCustomerToken', data)
  },
  check72Hours ({ getters }, data) {
    const formData = {}
    formData.receiptToken = data.token
    formData.campaignId = data.campaignId || getters.campaignId;
    return new Promise((resolve, reject) => {
      axios.post(`${APIUrl}/check72Hours`, formData)
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  uploadError ({ commit }) {
    commit('setModalOptions', { type: 'error', isActive: true, message: 'Ein Fehler ist aufgetreten, weil der Beleg zu oft hochgeladen wurde.' })

    setTimeout(() => {
      location.href = ''
    }, 3 * 1000)
  },
  getReturnFormFields: ({ getters }, receiptToken) => {
    let data = {};
    data.receiptToken = receiptToken;
    data.campaignId = getters.campaignId;
    data.lang = localStorage.getItem("lang")
    return new Promise((resolve, reject) => {
      axios.post(`${APIUrl}/returnForm`, data).then(res => {
        return resolve(res.data)
      }).catch(err => {
        return { success: false, error: err.message }
      })
    })
  },
}
